<app-badge customToolTip [contentTemplate]="dimensions">
  <mat-icon class="material-icons-outlined">analytics</mat-icon>
  <span>{{ datasource.datasetUsageCustomConfiguration$.value.nbDimensions$ | async }} {{ 'data_sources.dimensions' | translate | lowercase }}</span>
  <mat-icon class="material-icons-outlined icon-hover">info</mat-icon>
</app-badge>
<ng-template #dimensions>
  <app-source [item]="dimension.item$.value.payload" *ngFor="let dimension of datasource.datasetUsageCustomConfiguration$.value.dimensions$ | async"></app-source>
</ng-template>
